import { render, staticRenderFns } from "./AuthorAvatar.vue?vue&type=template&id=182a777c&scoped=true&"
import script from "./AuthorAvatar.vue?vue&type=script&lang=js&"
export * from "./AuthorAvatar.vue?vue&type=script&lang=js&"
import style0 from "./AuthorAvatar.vue?vue&type=style&index=0&id=182a777c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "182a777c",
  null
  
)

export default component.exports